import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { ResellersTabsCountersResponse } from "./resellersTabsCounters.types";

export const requestResellersTabsCounters =
  async (): Promise<ResellersTabsCountersResponse> => {
    return await instance.get(ApiRoutesResellers.ResellersTabsCounters);
  };
